import {
  AvatarProps as MuiAvatarProps,
  Avatar as MuiAvatar,
  SvgIconTypeMap,
  useTheme,
} from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { FC } from 'react';
import { getContrastTextColor } from '../../utils/get-contrast-text-color';

export type AvatarProps = MuiAvatarProps & {
  text?: string;
  size?: 'md' | 'lg' | 'xl';
  color?: 'random' | 'grey';
  icon?: OverridableComponent<SvgIconTypeMap<object>>;
};

const Avatar: FC<AvatarProps> = ({
  text,
  color,
  size = 'md',
  icon: Icon,
  ...rest
}) => {
  const theme = useTheme();

  const bgColors = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.error.main,
    theme.palette.warning.main,
    theme.palette.info.main,
    theme.palette.success.main,
  ];

  const sizes = {
    md: 24,
    lg: 32,
    xl: 40,
  };

  const fontSizes = {
    md: theme.fontSizes.sm,
    lg: undefined,
    xl: undefined,
  };

  const iconSizes = {
    md: 14,
    lg: undefined,
    xl: undefined,
  };

  const textIndex = text?.length ? text.charCodeAt(0) : 1;
  const bgColor = color === 'random' ? bgColors[textIndex % 6] : undefined;
  const iconColor = Icon && bgColor ? getContrastTextColor(bgColor) : undefined;

  return (
    <MuiAvatar
      sx={{
        backgroundColor: bgColor,
        width: sizes[size],
        height: sizes[size],
        fontSize: fontSizes[size],
      }}
      {...rest}
    >
      {text?.length ? (
        text.charAt(0).toUpperCase()
      ) : Icon ? (
        <Icon sx={{ color: iconColor, fontSize: iconSizes[size] }} />
      ) : null}
    </MuiAvatar>
  );
};

export default Avatar;
